import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import blanktem from '../../assets/blanktem.png';
import prebuilttem from '../../assets/prebuilttem.png';
import PrebuiltTemplatesModal from './PrebuiltTemplatesModal';

interface CreateTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  fromTab2?: string;
}

const CreateTemplateModal: React.FC<CreateTemplateModalProps> = ({
  isOpen,
  onClose,
  fromTab2,
}) => {
  const navigate = useNavigate();
  const [showPrebuiltModal, setShowPrebuiltModal] = useState(false);

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
      <div className='bg-white rounded-lg shadow-lg p-6 w-[600px]'>
        <div className='flex justify-between items-start mb-2'>
          <div>
            <h2 className='text-[20px] font-semibold text-[#3F5265]'>
              Choose a Template to Start
            </h2>
            <p className='text-[#657584] mb-4 text-[12px] mt-1'>
              Select a starting point for your email campaign. You can start
              from scratch, use a layout, or customize a pre-built theme.
            </p>
          </div>
          <button onClick={onClose}>✖</button> {/* Closes the modal */}
        </div>
        <div className='grid grid-cols-2 gap-6'>
          <div
            onClick={() => {
              onClose();
              // navigate('/templates/create');
              navigate(`/templates/create`, {
                state: { fromTab2: fromTab2 },
              });
            }}
            className='border rounded-md p-4 flex flex-col items-center justify-center cursor-pointer hover:shadow-md'
          >
            <img
              src={blanktem}
              alt='Blank Template'
              className='w-[100%] h-[100%] object-cover rounded mb-4'
            />
            <div className='text-left'>
              <h3 className='font-medium text-[#1F2937] text-[18px]'>
                Blank Template
              </h3>
              <p className='text-[14px] text-[#3F5265] mt-2'>
                Design your email from scratch using custom blocks and modules.
                Perfect for full creative control.
              </p>
            </div>
          </div>
          <div
            onClick={() => setShowPrebuiltModal(true)}
            className='border rounded-md p-4 flex flex-col items-center justify-center cursor-pointer hover:shadow-md'
          >
            <img
              src={prebuilttem}
              alt='Pre-built Templates'
              className='w-[100%] h-[100%] object-cover rounded mb-4'
            />
            <div className='text-left'>
              <h3 className='font-medium text-[#1F2937] text-[18px]'>
                Pre-built Templates
              </h3>
              <p className='text-[14px] text-[#3F5265] mt-2'>
                Choose from 100+ professionally designed templates optimized for
                various industries.
              </p>
            </div>
          </div>
        </div>
        <PrebuiltTemplatesModal
          isOpen={showPrebuiltModal}
          onClose={() => setShowPrebuiltModal(false)}
        />
      </div>
    </div>
  );
};

export default CreateTemplateModal;
